
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRemoveContainertypeDtoFormGroup() {
return new FormGroup({
    containertypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      